<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane tab="REPORTEADOR" key="1">
      <a-spin :spinning="loading">
        <div class="spin-content">
          <a-layout>
            <a-layout-sider v-if="allowView"  :width="400" breakpoint="md" collapsible theme="light">
              <a-menu mode="inline" style="min-height: 70px;" @select="seleccionarReporte"
                      :openKeys="defaultOpenKeys" @openChange="menuAbierto">
                <a-sub-menu :key="categoria" v-for="(report, categoria) in reportes">
                  <span slot="title"><a-icon type="container"/><span>{{categoria}}</span></span>
                  <a-menu-item :key="rp.id_report" v-for="rp in report">{{rp.name}}</a-menu-item>
                </a-sub-menu>
              </a-menu>
            </a-layout-sider>
            <a-layout-content v-else style="background: white; padding-left: 15px;">
                <a-alert
                  message="Advertencia"
                  type="warning"
                  show-icon
                >
                  <div slot="description" v-html="messageBiodata" @click="redirect"></div>
                </a-alert>
            </a-layout-content>
            <a-layout-content style="background: white; padding-left: 15px;">
              <a-form :form="form" @submit="generarReporte">
                <template v-for="param in parametros">
                  <a-tooltip>
                    <template slot="title" v-if="param.description">
                      {{param.description}}
                    </template>
                    <a-form-item v-bind="fiConfig" :label="param.name"
                                 v-if="param.type_parameter=='CARACTER'">
                      <a-input
                        v-decorator="[param.field_ireport, { rules: [{ required: param.mandatory == 'Y', message: 'Valor Requerido' }] }]"/>
                    </a-form-item>

                    <a-form-item v-bind="fiConfig" :label="param.name"
                                 v-else-if="param.type_parameter=='NUMBER'">
                      <a-input-number
                        style="width: 100%"
                        v-decorator="[param.field_ireport, { rules: [{ required: param.mandatory == 'Y', message: 'Valor Requerido' }] }]"/>
                    </a-form-item>
                    <a-form-item v-bind="fiConfig" :label="param.name"
                                 v-else-if="param.type_parameter=='DATE'">
                      <a-date-picker style="width: 100%"
                                     v-decorator="[param.field_ireport, { rules: [{ required: param.mandatory == 'Y', message: 'Valor Requerido' }] }]"/>
                    </a-form-item>
                    <g-select v-else-if="param.type_parameter=='LISTA'"
                              :decorator="[param.field_ireport, { rules: [{ required: param.mandatory == 'Y', message: 'Valor Requerido' }] }]"
                              :options="param.lov"
                              :label="param.name"
                              :formItemConfig="fiConfig"
                    ></g-select>

                    <g-lookup v-else-if="param.type_parameter=='LISTA_LIKE'"
                              :decorator="[param.field_ireport, { rules: [{ required: param.mandatory == 'Y', message: 'Valor Requerido' }] }]"
                              :label="param.name"
                              :formItemConfig="fiConfig"
                              :params="{
                                report_param_id:  param.id_report_parameter
                              }"
                              endpoint="report/lista_like">
                    </g-lookup>
                    <span v-else>Tipo de parámetro {{param.name}} no soportado.</span>
                  </a-tooltip>
                </template>
                <g-select
                  :decorator="['tipo_salida', {rules: [{ required: true, message: 'Valor Requerido' }] }]"
                  v-if="reporte"
                  label="Tipo Salida"
                  :options="tipoSalidas"
                  :formItemConfig="fiConfig"
                ></g-select>
                <a-form-item :wrapper-col="{offset: 4, span: 20}" v-if="reporte">
                  <a-button type="primary" html-type="submit">
                    Generar Reporte
                  </a-button>
                </a-form-item>
              </a-form>
            </a-layout-content>
          </a-layout>
        </div>
      </a-spin>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'

  let tiposSalida = {
    pdf: [{text: 'PDF', value: 'PDF'}],
    xls: [{text: 'XLS', value: 'XLS'}],
    pyx: [{text: 'PDF', value: 'PDF'}, {text: 'XLS', value: 'XLS'}]
  }

  export default {
    data () {
      return {
        message: this.$getConfigValue('MENSAJE_REPORTES_PDF_BIODATA_INCOMPLETO',
          'No puede visualziar los reportes porque no ha diligenciado los datos basicos en biodata'),
        allowView: true,
        reporte: false,
        loading: true,
        tipoSalidas: [],
        reportes: [],
        parametros: [],
        defaultOpenKeys: [],
        form: this.$form.createForm(this, {
          name: 'reporte'
        }),
        fiConfig: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        }
      }
    },
    mounted () {
      this.http = new HttpUtil('report/disponibles')
      this.allowViewUser()
      this.http.get(null, (response) => {
        this.reportes = response.data
        for (let categoria in this.reportes) {
          this.defaultOpenKeys = [categoria]
          break
        }
        this.loading = false
      }, (error) => {
        console.log(error)
      })
      this.validaUsuario()
    },
    methods: {
      seleccionarReporte (e) {
        this.loading = true
        let encontrado = false
        for (let categoria in this.reportes) {
          if (encontrado) break
          if (this.reportes.hasOwnProperty(categoria)) {
            let cat = this.reportes[categoria]
            for (let i = 0; i < cat.length; i++) {
              if (cat[i].id_report === e.key) {
                this.reporte = cat[i]
                encontrado = true
                break
              }
            }
          }
        }

        this.parametros = []
        this.tipoSalidas = []

        switch (this.reporte.tipo_salida) {
          case 'PDF':
            this.tipoSalidas = tiposSalida.pdf
            this.$nextTick(() => {
              this.form.setFieldsValue({
                tipo_salida: 'PDF'
              })
            })
            break
          case 'XLS':
            this.tipoSalidas = tiposSalida.xls
            this.$nextTick(() => {
              this.form.setFieldsValue({
                tipo_salida: 'XLS'
              })
            })
            break
          case 'PYX':
            this.tipoSalidas = tiposSalida.pyx
            this.$nextTick(() => {
              this.form.setFieldsValue({
                tipo_salida: 'PDF'
              })
            })
            break
        }

        this.http.getInstance().get('report/parametros/disponibles', {params: {id_report: e.key}})
          .then((response) => {
            this.parametros = response.data
            this.parametros.map((param) => {
              if (param.type_parameter === 'LISTA') {
                if (!JsUtils.isEmpty(param.lov)) {
                  param.lov.map((item) => {
                    let colsDeseadas = param.col_others.toLowerCase().trim().split(',')
                    let concatVal = ''
                    colsDeseadas.map((colDeseada) => {
                      concatVal += item[colDeseada.trim()] + ' '
                    })

                    item.text = concatVal.trim()
                    item.value = item[param.col_id_name.toLowerCase()]
                  })
                }
              }
            })
          }).catch((error) => {
          // TODO manejar este error
          }).then(() => {
            this.loading = false
          })
      },
      generarReporte (e) {
        e.preventDefault()
        this.form.validateFields((err, values) => {
          // NO HE PODIDO SACAR LOS VALORES DEL FORMULARIO SE DEBE HACER PRUEBAS.!!!
          if (!err) {
            this.loading = true
            this.http.getInstance().post('report/generar', {
              id_report: this.reporte.id_report,
              tipo_salida: values.tipo_salida,
              params: values
            }, {responseType: 'arraybuffer'}).then((response) => {
              console.log(response)
              let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
              fileURL = window.URL.createObjectURL(fileURL)
              let fileLink = document.getElementById('file_link_elm')
              if (fileLink === null) {
                fileLink = document.createElement('a')
                fileLink.setAttribute('id', 'file_link_elm')
                document.body.appendChild(fileLink)
              }

              fileLink.setAttribute('href', fileURL)
              fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
              fileLink.click()
            }).catch((error) => {
              console.log(error)
            }).then(() => {
              this.loading = false
            })
          }
        })
      },
      menuAbierto (openKeys) {
        const latestOpenKey = openKeys.find(key => this.defaultOpenKeys.indexOf(key) === -1)
        this.defaultOpenKeys = latestOpenKey ? [latestOpenKey] : []
      },
      allowViewUser () {
        this.http.getInstance().get('report/allow').then((response) => {
          this.allowView = response.data.allow
        }).catch(() => {
        })
      },
      redirect () {
        this.$router.push({name: 'Biodata'})
      },
      validaUsuario () {
        this.http = new HttpUtil('ss/valida_usuario')
        this.http.get(null, (response) => {
          if (parseInt(response.data) === 1) {
            this.$confirm({
              title: 'Advertencia',
              content: this.$getConfigValue('COMPETENCIA_MENSAJE_REPORTE'),
              onOk: () => {
                return new Promise((resolve, reject) => {
                  resolve()
                }).catch(() => console.log('Oops errors!'))
              },
              onCancel: () => {}
            })
          }
        }, () => {})
      }
    },
    computed: {
      messageBiodata () {
        return this.message + ' <a>Ir a Biodata</a>'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Report/Report.vue